/**
 * クラス名：係数パラメータ
 * 説明：係数情報一覧画面
 * 作成者：ケイ
 * 作成日：2023/05/01
 * バージョン：1.0
 */
import {
  Table,
  Form,
  Button,
  Row,
  Input,
  Col,
  Modal,
  Select,
  Checkbox,
  Space,
  Image,
  Radio,
  DatePicker,
  Spin,
} from 'antd';
import { Table as RTable } from 'react-bootstrap';
import { CSVLink, CSVDownload } from 'react-csv';
import React, { useRef, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Outlet, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { StatusCodes } from 'http-status-codes';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import { CloseOutlined, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import SplitPane, { Pane } from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';
import { createCoeffCSV, getCompanyInfo } from '../../../common/CommonAPI';
import { ErrorMessage } from '../../../common/Message';

import {
  confirmHakiContent,
  confirmUpdateContent,
  confirmDiscardContent,
  confirmCreateContent,
  confirmModalTitle,
  confirmDeleteContent,
  confirmDiscardAndDeleteContent,
  commonModal,
  commonFooter,
  authorizeError,
  error,
  commonDeleteFooter,
  commonResponsiveConfirmModal,
  bulkDeleteModalTitle,
  complete,
  deleteModalTitle,
  commonDeleteAllFooter,
} from '../../../common/CommonModal';
import CoefficientDetails from './CoefficientDetails';
import {
  dataStateList,
  today,
  TextArea,
  getAccessToken,
  updateAccessToken,
  formValidatorMode,
  handleKeyPress,
  toDecimal,
  regexExp,
  toHalfWidth,
  discardChange,
  isDigit,
  isDecimal,
  formatDate,
  formatDateString,
  todayTime,
} from '../../../common/Common';
import checked from '../../../../assets/images/checked.png';
import sort_up from '../../../../assets/images/sort_up.png';
import sort_down from '../../../../assets/images/sort_down.png';
import { size } from 'lodash';
import Draggable from 'react-draggable';

dayjs.extend(customParseFormat);
const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';

const columns = [
  {
    id: '1',
    title: 'No',
    dataIndex: 'no',
    width: 50,
    render: (id, record, index) => {
      return index + 1;
    },
    className: 'cm-a-right',
  },

  {
    id: '2',
    title: 'コード',
    dataIndex: 'code',
    width: 120,
    sorter: (a, b) => a.code?.toUpperCase()?.localeCompare(b.code?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'code',
  },
  {
    id: '3',
    title: '名称',
    dataIndex: 'name',
    width: 150,
    sorter: (a, b) => a.name?.toUpperCase()?.localeCompare(b.name?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'name',
  },
  {
    id: '4',
    title: '係数',
    dataIndex: 'coeff',
    width: 100,
    className: 'cm-a-right',
    render: (_, record) => <label style={{ fontSize: '13px' }}>{toDecimal(record.coeff, 2)}</label>,
    sorter: (a, b) => a.coeff - b.coeff,
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'coeff',
  },

  {
    id: '5',
    title: 'ソート番号',
    dataIndex: 'sortNum',
    width: 95,
    className: 'cm-a-right',
    sorter: (a, b) => a.sortNum - b.sortNum,
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'sortNum',
  },
  {
    id: '6',
    title: '作成日',
    dataIndex: 'created',
    render: (id, record, index) => {
      return record['created']?.split('T')[0];
    },
    width: 100,
    sorter: (a, b) => a.created?.toUpperCase()?.localeCompare(b.created?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'created',
  },
  {
    id: '7',
    title: '更新日',
    dataIndex: 'modified',
    render: (id, record, index) => {
      return record['modified']?.split('T')[0];
    },
    width: 100,
    sorter: (a, b) => a.modified?.toUpperCase()?.localeCompare(b.modified?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'modified',
  },
  {
    id: '8',
    title: '備考',
    dataIndex: 'remarks',
    width: 200,
    sorter: (a, b) => a.remarks?.toUpperCase()?.localeCompare(b.remarks?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'remarks',
  },
  {
    id: '9',
    title: '表示',
    dataIndex: 'isUsed',
    width: 95,
    render: (index, item) => {
      return item['isUsed'] ? (
        <Image
          preview={false}
          width={13}
          src={checked}
          style={{ marginLeft: '3px' }}
          /* key={item['key']} */
          id={item['id']}
        />
      ) : (
        <></>
      );
    },
    className: 'cm-a-center',
    sorter: (a, b) => a.isUsed - b.isUsed,
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'isUsed',
  },
  {
    id: '10',
    title: '',
    dataIndex: 'tableNo',
    hidden: true,
  },
]?.filter((item) => !item.hidden);

const deliTimeColumns = [
  {
    id: '1',
    title: 'No',
    dataIndex: 'no',
    width: 50,
    render: (id, record, index) => {
      return index + 1;
    },
    className: 'cm-a-right',
  },

  {
    id: '2',
    title: 'コード',
    dataIndex: 'code',
    width: 120,
    sorter: (a, b) => a.code?.toUpperCase()?.localeCompare(b.code?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'code',
  },
  {
    id: '3',
    title: '名称',
    dataIndex: 'name',
    width: 150,
    sorter: (a, b) => a.name?.toUpperCase()?.localeCompare(b.name?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'name',
  },
  {
    id: '4',
    title: '係数',
    dataIndex: 'coeff',
    width: 100,
    className: 'cm-a-right',
    render: (_, record) => <label style={{ fontSize: '13px' }}>{toDecimal(record.coeff, 2)}</label>,
    sorter: (a, b) => a.coeff - b.coeff,
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'coeff',
  },
  /* {
    id: '5',
    title: '目安日数',
    dataIndex: 'daysTh',
    width: 100,
    className: 'cm-a-right',
  }, */

  {
    id: '6',
    title: 'ソート番号',
    dataIndex: 'sortNum',
    width: 95,
    className: 'cm-a-right',
    sorter: (a, b) => a.sortNum - b.sortNum,
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'sortNum',
  },
  {
    id: '7',
    title: '作成日',
    dataIndex: 'created',
    render: (id, record, index) => {
      return record['created']?.split('T')[0];
    },
    width: 100,
    sorter: (a, b) => a.created?.toUpperCase()?.localeCompare(b.created?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'created',
  },
  {
    id: '8',
    title: '更新日',
    dataIndex: 'modified',
    render: (id, record, index) => {
      return record['modified']?.split('T')[0];
    },
    width: 100,
    sorter: (a, b) => a.modified?.toUpperCase()?.localeCompare(b.modified?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'modified',
  },
  {
    id: '9',
    title: '備考',
    dataIndex: 'remarks',
    width: 200,
    sorter: (a, b) => a.remarks?.toUpperCase()?.localeCompare(b.remarks?.toUpperCase()),
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'remarks',
  },
  {
    id: '10',
    title: '表示',
    dataIndex: 'isUsed',
    width: 95,
    render: (index, item) => {
      return item['isUsed'] ? (
        <Image preview={false} width={13} src={checked} style={{ marginLeft: '3px' }} id={item['id']} />
      ) : (
        <></>
      );
    },
    className: 'cm-a-center',
    sorter: (a, b) => a.isUsed - b.isUsed,
    sortIcon: ({ sortOrder }) => (
      <>
        <Image
          preview={false}
          src={sort_up}
          style={{ display: sortOrder === 'ascend' ? 'block' : 'none', width: '15px' }}
        />
        <Image
          preview={false}
          src={sort_down}
          style={{ display: sortOrder === 'descend' ? 'block' : 'none', width: '15px' }}
        />
      </>
    ),
    key: 'isUsed',
  },
]?.filter((item) => !item.hidden);

const tableColumns = columns?.map((item) => ({
  ...item,
}));

const deliTimeTableColumns = deliTimeColumns?.map((item) => ({
  ...item,
}));

const CoefficientParamList = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    setSplitPaneSize: setSplitPaneSize,
    createNewProcess: createNewProcess,
    showXMLInputModal: showXMLInputModal,
    bulkEditProcess: bulkEditProcess,
    deleteProcess: deleteProcess,
    bulkDeleteProcess: bulkDeleteProcess, // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
    deleteAllProcess: deleteAllProcess,
    showCSVInputModal: showCSVInputModal,
    getEditMode: editMode,
    updateEditMode: setEditMode,
    discardChange: discardChange,
    setDiscardChangeMode: setDiscardChangeMode,
    setEditModeCancelConfirm: setEditModeCancelConfirm,
    getCsvExportFileName: csvExportFileName,
    getCsvExportData: getCsvExportData,
    submitCsvImportData: submitCsvImportData,
  }));

  const csvExportFileName = `係数_${formatDateString(todayTime())}.csv`;

  const inputItemRef = {};
  const messageRef = useRef([]);

  let checkedRow = [];
  const detailRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  const coefficientType = [
    { value: 1, label: '受注係数' },
    { value: 2, label: '納期係数' },
    { value: 3, label: '購入品係数' },
    { value: 4, label: '管理費係数' },
    // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
    { value: 5, label: '発注分類係数' },
    { value: 6, label: '公差係数' },
    { value: 7, label: '仕上げレベル係数' },
    { value: 8, label: '最終用途係数' },
    //2025/07/22 現行Estと合わせて追加（段取係数、子部品生産個数係数）
    { value: 9, label: '段取係数' },
    { value: 10, label: '子部品生産個数係数' },
  ];

  const coefficientTypeAdd = [
    { value: 1, label: '受注係数' },
    { value: 2, label: '納期係数' },
    { value: 3, label: '購入品係数' },
    { value: 4, label: '管理費係数' },
    // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
    { value: 6, label: '公差係数' },
    { value: 7, label: '仕上げレベル係数' },
    { value: 8, label: '最終用途係数' },
    //2025/07/22 現行Estと合わせて追加（段取係数、子部品生産個数係数）
    { value: 9, label: '段取係数' },
    { value: 10, label: '子部品生産個数係数' },
  ];

  const [paramSelected, setParamSelected] = useState('coefficient');
  const [paramType, setParamType] = useState('common');
  const [orderCoeffData, setOrderCoeffData] = useState([]);
  const [orderCoeffDataTmp, setOrderCoeffDataTmp] = useState([]);
  const [orderFilteredData, setOrderFilteredData] = useState([]);
  const [deliTimeCoeffData, setDeliTimeCoeffData] = useState([]);
  const [deliTimeCoeffDataTmp, setDeliTimeCoeffDataTmp] = useState([]);
  const [deliTimeFilteredData, setDeliTimeFilteredData] = useState([]);
  const [purchaseCoeffData, setPurchaseCoeffData] = useState([]);
  const [purchaseCoeffDataTmp, setPurchaseCoeffDataTmp] = useState([]);
  const [purchaseFilteredData, setPurchaseFilteredData] = useState([]);
  const [maintainCoeffData, setMaintainCoeffData] = useState([]);
  const [maintainCoeffDataTmp, setMaintainCoeffDataTmp] = useState([]);
  const [maintainFilteredData, setMaintainFilteredData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [tempCoefficientData, setTempCoefficientData] = useState([]);

  // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
  const [orderTypesCoeffData, setOrderTypesCoeffData] = useState([]);
  const [toleranceCoeffData, setToleranceCoeffData] = useState([]);
  const [weldFinishLevelCoeffData, setWeldFinishLevelCoeffData] = useState([]);
  const [finalPurposCoeffData, setFinalPurposCoeffData] = useState([]);
  const [orderTypesFilteredData, setOrderTypesFilteredData] = useState([]);
  const [toleranceFilteredData, setToleranceFilteredData] = useState([]);
  const [weldFinishLevelFilteredData, setWeldFinishLevelFilteredData] = useState([]);
  const [finalPurposFilteredData, setFinalPurposFilteredData] = useState([]);
  //

  const [editMode, setEditMode] = useState(false);
  // 発生した処理タイプ
  const [discardChangeMode, setDiscardChangeMode] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [changeRecordKey, setChangeRecordKey] = useState(0);
  const [changeTableNo, setChangeTableNo] = useState();

  const [display, setDisplay] = useState();
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [coefficient, setCoefficient] = useState('');
  const [estimateDays, setEstimateDays] = useState('');
  const [remarks, setRemarks] = useState('');
  const [sortNo, setSortNo] = useState('');
  const [created, setCreated] = useState('');
  const [updated, setUpdated] = useState(today);
  const [tableNo, setTableNo] = useState(1);

  const [dataState, setDataState] = useState(1);
  const [keyword, setKeyWord] = useState('');
  const [isFilterFlg, setIsFilterFlg] = useState(false);

  const [outsourcingChecked, setOutsourcingChecked] = useState(false);
  const [invalidFlgChecked, setInvalidFlgChecked] = useState(false);
  const [hasCheckData, setHasCheckData] = useState(true);
  const [chkData, setChkData] = useState(0);
  const [selectedRowsData, setSelectedRowsData] = useState([]);

  const [isBulkEdit, setIsBulkEdit] = useState(false);
  const [isCreateNew, setIsCreateNew] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [visibleCSVInput, setVisibleCSVInput] = useState(false);
  const [visibleCSVOutput, setVisibleCSVOutput] = useState(false);
  const [visibleXMLInput, setVisibleXMLInput] = useState(false);
  const [childTitle, setChildTitle] = useState('');

  const [createConfirm, setCreateConfirm] = useState(false);
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [updateConfirm, setUpdateConfirm] = useState(false);
  const [editModeCancelConfirm, setEditModeCancelConfirm] = useState(false);

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  // 一括削除
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [deleteSelectedRowKeys, setDeleteSelectedRowKeys] = useState([]);

  const [isDeleteAll, setIsDeleteAll] = useState(false);
  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const [selectedRowsOrderTable, setSelectedRowsOrderTable] = useState([]);
  const [selectedRowsDeliTimeTable, setSelectedRowsDeliTimeTable] = useState([]);
  const [selectedRowsPurchaseTable, setSelectedRowsPurchaseTable] = useState([]);
  const [selectedRowsMaintainTable, setSelectedRowsMaintainTable] = useState([]);
  const [selectedRowsToleranceTable, setSelectedRowsToleranceTable] = useState([]);
  const [selectedRowsWeldFinishTable, setSelectedRowsWeldFinishTable] = useState([]);
  const [selectedRowsFinalPurposTable, setSelectedRowsFinalPurposTable] = useState([]);
  const [selectedRowsSetupTable, setSelectedRowsSetupTable] = useState([]);
  const [selectedRowsProductTable, setSelectedRowsProductTable] = useState([]);

  // 一括編集
  const [chkrowscount, setChkRowsCount] = useState(0);
  const [bulkEditOrdSelectedRow, setBulkEditOrdSelectedRow] = useState([]);
  const [bulkEditDltSelectedRow, setBulkEditDltSelectedRow] = useState([]);
  const [bulkEditPurSelectedRow, setBulkEditPurSelectedRow] = useState([]);
  const [bulkEditMainSelectedRow, setBulkEditMainSelectedRow] = useState([]);
  const [bulkEditOrdSelectedKeys, setBulkEditOrdSelectedKeys] = useState([]);
  const [bulkEditDltSelectedKeys, setBulkEditDltSelectedKeys] = useState([]);
  const [bulkEditPurSelectedKeys, setBulkEditPurSelectedKeys] = useState([]);
  const [bulkEditMainSelectedKeys, setBulkEditMainSelectedKeys] = useState([]);

  const [isOrderCoeff, setIsOrderCoeff] = useState(true);
  const [isDeliTimeCoeff, setIsDeliTimeCoeff] = useState(true);
  const [isPurchaseCoeff, setIsPurchaseCoeff] = useState(true);
  const [isMaintainCoeff, setIsMaintainCoeff] = useState(true);

  // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
  const [isOrderTypeCoeff, setIsOrderTypeCoeff] = useState(true);
  const [isToleranceCoeff, setIsToleranceCoeff] = useState(true);
  const [isWeldFinishLevelCoeff, setIsWeldFinishLevelCoeff] = useState(true);
  const [isFinalPurposCoeff, setIsFinalPurposCoeff] = useState(true);

  const [isBulkEditOrderTypeCoeff, setIsBulkEditOrderTypeCoeff] = useState(true);
  const [isBulkEditToleranceCoeff, setIsBulkEditToleranceCoeff] = useState(true);
  const [isBulkEditWeldFinishLevelCoeff, setIsBulkEditWeldFinishLevelCoeff] = useState(true);
  const [isBulkEditFinalPurposCoeff, setIsBulkEditFinalPurposCoeff] = useState(true);

  const [bulkEditOrderTypeSelectedRow, setBulkEditOrderTypeSelectedRow] = useState([]);
  const [bulkEditToleranceSelectedRow, setBulkEditToleranceSelectedRow] = useState([]);
  const [bulkEditWeldFinishLevelSelectedRow, setBulkEditWeldFinishLevelSelectedRow] = useState([]);
  const [bulkEditFinalPurposSelectedRow, setBulkEditFinalPurposSelectedRow] = useState([]);

  const [bulkEditOrderTypeSelectedKeys, setBulkEditOrderTypeSelectedKeys] = useState([]);
  const [bulkEditToleranceSelectedKeys, setBulkEditToleranceSelectedKeys] = useState([]);
  const [bulkEditWeldFinishLevelSelectedKeys, setBulkEditWeldFinishLevelSelectedKeys] = useState([]);
  const [bulkEditFinalPurposSelectedKeys, setBulkEditFinalPurposSelectedKeys] = useState([]);
  //

  const [isBulkEditOrderCoeff, setIsBulkEditOrderCoeff] = useState(true);
  const [isBulkEditDeliTimeCoeff, setIsBulkEditDeliTimeCoeff] = useState(true);
  const [isBulkEditPurchaseCoeff, setIsBulkEditPurchaseCoeff] = useState(true);
  const [isBulkEditMaintainCoeff, setIsBulkEditMaintainCoeff] = useState(true);

  // 新規作成
  const [coeffType, setCoeffType] = useState(1);

  // Content Resize
  const [sizes, setSizes] = useState(['45%']);

  const [showEdtConfirmOK, setShowEdtConfirmOK] = useState();
  const [showEdtConfirmCancle, setShowEdtConfirmCancle] = useState();

  // 202507722
  const [isSetupCoeff, setIsSetupCoeff] = useState(true);
  const [isProductCoeff, setIsProductCoeff] = useState(true);
  const [setupCoeffData, setSetupCoeffData] = useState([]);
  const [setupCoeffDataTmp, setSetupCoeffDataTmp] = useState([]);
  const [setupFilteredData, setSetupFilteredData] = useState([]);
  const [productCoeffData, setProductCoeffData] = useState([]);
  const [productCoeffDataTmp, setProductCoeffDataTmp] = useState([]);
  const [productFilteredData, setProductFilteredData] = useState([]);
  // Idで降順する
  // const descOrderById = (data) => {
  //   if (data?.length > 0) {
  //     let sortedList = data?.sort((a, b) => b.id - a.id);
  //     return sortedList;
  //   } else {
  //     return data;
  //   }
  // };

  // 取引先情報をDBから取得する
  async function getCoefficientData() {
    let tempData = [];
    let selectedData = [];
    let orderCoeffDatas = [];
    let deliTimeCoeffDatas = [];
    let maintainCoeffDatas = [];
    let coeffPurchases = [];

    // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
    let coeffOrderTypes = [];
    let coeffTolerance = [];
    let coeffWeldFinishLevel = [];
    let coeffFinalPurpose = [];
    //段取係数、子部品生産個数
    let coeffSetups = [];
    let coeffProducts = [];

    try {
      props?.loading(true); // Waitingダイアログを表示にする
      tempData = await getCompanyInfo();
      orderCoeffDatas = tempData?.length > 0 ? tempData[0]?.coeffOrders?.filter((item) => !item.isDeleted) : [];

      selectedData = orderCoeffDatas;
      deliTimeCoeffDatas =
        tempData?.length > 0 ? tempData[0]?.coeffDeliveryDates?.filter((item) => !item.isDeleted) : [];
      maintainCoeffDatas = tempData?.length > 0 ? tempData[0]?.coeffManagements?.filter((item) => !item.isDeleted) : [];
      coeffPurchases = tempData?.length > 0 ? tempData[0]?.coeffPurchases?.filter((item) => !item.isDeleted) : [];

      // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
      coeffOrderTypes = tempData?.length > 0 ? tempData[0]?.coeffOrderTypes?.filter((item) => !item.isDeleted) : [];
      coeffTolerance = tempData?.length > 0 ? tempData[0]?.coeffTolerance?.filter((item) => !item.isDeleted) : [];
      coeffWeldFinishLevel =
        tempData?.length > 0 ? tempData[0]?.coeffWeldFinishLevel?.filter((item) => !item.isDeleted) : [];
      coeffFinalPurpose = tempData?.length > 0 ? tempData[0]?.coeffFinalPurpose?.filter((item) => !item.isDeleted) : [];

      //段取係数、子部品生産個数
      coeffSetups = tempData?.length > 0 ? tempData[0]?.coeffSetups?.filter((item) => !item.isDeleted) : [];
      coeffProducts = tempData?.length > 0 ? tempData[0]?.coeffProducts?.filter((item) => !item.isDeleted) : [];

      setOrderTypesCoeffData(coeffOrderTypes);
      setOrderTypesFilteredData(coeffOrderTypes);

      setToleranceCoeffData(coeffTolerance);
      setToleranceFilteredData(coeffTolerance);

      setWeldFinishLevelCoeffData(coeffWeldFinishLevel);
      setWeldFinishLevelFilteredData(coeffWeldFinishLevel);

      setFinalPurposCoeffData(coeffFinalPurpose);
      setFinalPurposFilteredData(coeffFinalPurpose);

      setDeliTimeCoeffData(deliTimeCoeffDatas);
      setDeliTimeFilteredData(deliTimeCoeffDatas);

      setPurchaseCoeffData(coeffPurchases);
      setPurchaseFilteredData(coeffPurchases);

      setMaintainCoeffData(maintainCoeffDatas);
      setMaintainFilteredData(maintainCoeffDatas);

      setOrderCoeffData(orderCoeffDatas);
      setOrderFilteredData(orderCoeffDatas);

      //段取係数、子部品生産個数
      setSetupCoeffData(coeffSetups);
      setSetupFilteredData(coeffSetups);
      setProductCoeffData(coeffProducts);
      setProductFilteredData(coeffProducts);

      let rowSelectTbl = [];
      let tbl;
      let lastKey;

      switch (true) {
        case orderCoeffDatas?.length != 0 && orderCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = orderCoeffDatas?.filter((item) => item.isUsed);
          tbl = 1;
          lastKey = rowSelectTbl[0]?.id;
          break;
        case deliTimeCoeffDatas?.length != 0 && deliTimeCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = deliTimeCoeffDatas?.filter((item) => item.isUsed);
          tbl = 2;
          lastKey = rowSelectTbl[0]?.id;
          break;
        case coeffPurchases?.length != 0 && coeffPurchases?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = coeffPurchases?.filter((item) => item.isUsed);
          tbl = 3;
          lastKey = rowSelectTbl[0]?.id;
          break;
        case maintainCoeffDatas?.length != 0 && maintainCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = maintainCoeffDatas?.filter((item) => item.isUsed);
          tbl = 4;
          lastKey = rowSelectTbl[0]?.id;
          break;
        // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
        case coeffOrderTypes?.length != 0 && coeffOrderTypes?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = coeffOrderTypes?.filter((item) => item.isUsed);
          tbl = 5;
          lastKey = rowSelectTbl[0]?.id;
          break;
        case coeffTolerance?.length != 0 && coeffTolerance?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = coeffTolerance?.filter((item) => item.isUsed);
          tbl = 6;
          lastKey = rowSelectTbl[0]?.id;
          break;
        case coeffWeldFinishLevel?.length != 0 && coeffWeldFinishLevel?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = coeffWeldFinishLevel?.filter((item) => item.isUsed);
          tbl = 7;
          lastKey = rowSelectTbl[0]?.id;
          break;
        case coeffFinalPurpose?.length != 0 && coeffFinalPurpose?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = coeffFinalPurpose?.filter((item) => item.isUsed);
          tbl = 8;
          lastKey = rowSelectTbl[0]?.id;
          break;
        case coeffSetups.length != 0 && coeffSetups?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = coeffSetups?.filter((item) => item.isUsed);
          tbl = 9;
          lastKey = rowSelectTbl[0]?.id;
          break;
        case coeffProducts.length != 0 && coeffProducts?.filter((item) => item.isUsed)?.length != 0:
          rowSelectTbl = coeffProducts?.filter((item) => item.isUsed);
          tbl = 10;
          lastKey = rowSelectTbl[0]?.id;
          break;
        default:
          rowSelectTbl = orderCoeffDatas;
          tbl = 1;
          lastKey = rowSelectTbl[0]?.id;
      }

      // 前回選択された行がある場合
      if (
        props.initialParam === 'coefficient' &&
        props.selectedRowId !== undefined &&
        props.selectedRowId !== 0 &&
        props.rowSelectTbl !== undefined &&
        props.rowSelectTbl !== 0
      ) {
        lastKey = props.selectedRowId;
        switch (props.rowSelectTbl) {
          case 1:
            rowSelectTbl = orderCoeffDatas?.filter((item) => item.isUsed);
            tbl = 1;
            break;
          case 2:
            rowSelectTbl = deliTimeCoeffDatas?.filter((item) => item.isUsed);
            tbl = 2;
            break;
          case 3:
            rowSelectTbl = coeffPurchases?.filter((item) => item.isUsed);
            tbl = 3;
            break;
          case 4:
            rowSelectTbl = maintainCoeffDatas?.filter((item) => item.isUsed);
            tbl = 4;
            break;
          // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
          case 5:
            rowSelectTbl = coeffOrderTypes?.filter((item) => item.isUsed);
            tbl = 5;
            break;
          case 6:
            rowSelectTbl = coeffTolerance?.filter((item) => item.isUsed);
            tbl = 6;
            break;
          case 7:
            rowSelectTbl = coeffWeldFinishLevel?.filter((item) => item.isUsed);
            tbl = 7;
            break;
          case 8:
            rowSelectTbl = coeffFinalPurpose?.filter((item) => item.isUsed);
            tbl = 8;
            break;
          case 9:
            rowSelectTbl = coeffSetups?.filter((item) => item.isUsed);
            tbl = 9;
            break;
          case 10:
            rowSelectTbl = coeffProducts?.filter((item) => item.isUsed);
            tbl = 10;
            break;
          default:
            rowSelectTbl = orderCoeffDatas;
            tbl = 1;
        }
        let propFilterDatas =
          props.initialParam === 'coefficient' && props?.filterDatas !== undefined
            ? props?.filterDatas
            : {
                keyword: keyword,
                dataState: dataState,
              };
        if (propFilterDatas?.keyword !== undefined) setKeyWord(propFilterDatas?.keyword);
        if (propFilterDatas?.dataState !== undefined) setDataState(propFilterDatas?.dataState);
      }
      setIsFilterFlg(true);

      let record = getSelectedData(rowSelectTbl, lastKey);
      onRowSelectWithoutEditMode(record, tbl);

      setSelectedRowKeys(lastKey);
      setSelectedData(record);
      setSelectedRowsData(rowSelectTbl);
      setTableNo(tbl);

      navigate(':common.coefficient');
      setParamSelected('coefficient');
      setParamType('common');
      setIsOrderCoeff(true);
      props.setParam(paramType, paramSelected);
      props?.loading(false); // Waitingダイアログを非表示にする
    } catch (e) {
      error(e.message);
      return;
    }
  }

  useEffect(() => {
    getCoefficientData();
  }, [paramType, paramSelected]);

  useEffect(() => {
    if (props.showConfirmMsgs !== undefined) {
      setShowEdtConfirmOK(props.showConfirmMsgs?.editOk);
      setShowEdtConfirmCancle(props.showConfirmMsgs?.editCancel);
    } else {
      setShowEdtConfirmOK(true);
      setShowEdtConfirmCancle(true);
    }
  }, [props.showConfirmMsgs]);

  /* useEffect(() => {
    let tempData = [];
    let selectedData = [];

    tempData =
      localStorage.getItem('paramCommonOrderCoeff') == undefined
        ? []
        : JSON.parse(localStorage.getItem('paramCommonOrderCoeff'));
    selectedData = tempData;
    setOrderCoeffData(tempData);
    setOrderFilteredData(tempData);
    // setSelectedRowKeys(tempData?.length);
    // setSelectedData(selectedData[selectedData?.length - 1]);
    setSelectedRowKeys(1);
    setSelectedData(selectedData != undefined && selectedData?.length > 0 ? selectedData[1] : []);
    setSelectedRowsData(tempData);
    setTableNo(1);
    setDataState(1);

    tempData = [];
    tempData =
      localStorage.getItem('paramCommonDeliTimeCoeff') == undefined
        ? []
        : JSON.parse(localStorage.getItem('paramCommonDeliTimeCoeff'));
    setDeliTimeCoeffData(tempData);
    setDeliTimeFilteredData(tempData);

    tempData = [];
    tempData =
      localStorage.getItem('paramCommonPurchaseCoeff') == undefined
        ? []
        : JSON.parse(localStorage.getItem('paramCommonPurchaseCoeff'));
    setPurchaseCoeffData(tempData);
    setPurchaseFilteredData(tempData);

    tempData = [];
    tempData =
      localStorage.getItem('paramCommonMaintainCoeff') == undefined
        ? []
        : JSON.parse(localStorage.getItem('paramCommonMaintainCoeff'));
    setMaintainCoeffData(tempData);
    setMaintainFilteredData(tempData);

    navigate(':common.coefficient');
    setParamSelected('coefficient');
    setParamType('common');
    setIsOrderCoeff(true);
    props.setParam(paramType, paramSelected);
  }, []); */

  // フラグ又はキーワードに変更された場合、
  useEffect(() => {
    if (isFilterFlg) {
      // 絞り込み、
      getDataByFilter();
    }
  }, [
    keyword,
    dataState,
    orderCoeffDataTmp,
    deliTimeCoeffDataTmp,
    purchaseCoeffDataTmp,
    maintainCoeffDataTmp,
    isFilterFlg,
  ]);

  // 編集中破棄確認ポップアップに「OK」又は「キャンセル」を押下
  useEffect(() => {
    if (!editMode && !editModeCancelConfirm) {
      let tempData = [];
      switch (discardChangeMode?.no) {
        case discardChange[0]?.no: // 編集中に行を選択した場合、
          tempData = getDataByType(changeTableNo);
          setTableNo(changeTableNo);
          setSelectedRowKeys(changeRecordKey);
          setSelectedData(getSelectedData(tempData, changeRecordKey));
          break;
        case discardChange[1]?.no: // 検索
          getDataByFilter();
          break;
        case discardChange[2]?.no: // 一括編集
        case discardChange[3]?.no: // 新規作成
          tempData = getDataByType(tableNo);
          setSelectedData(getSelectedData(tempData, selectedRowKeys));
          discardChangeMode?.no === discardChange[2]?.no ? bulkEditProcess() : createNewProcess();
          break;
        case discardChange[4]?.no: // CSV入力
          onClickCSVImport();
          break;
        case discardChange[5]?.no: // CSV出力
          onClickCSVExport();
          break;
      }
    }
  }, [editModeCancelConfirm]);

  // 一括編集の行チェックボックスを押下
  useEffect(() => {
    let chkCount =
      bulkEditOrdSelectedRow?.length +
      bulkEditDltSelectedRow?.length +
      bulkEditPurSelectedRow?.length +
      bulkEditMainSelectedRow?.length;
    setChkRowsCount(chkCount);
  }, [bulkEditOrdSelectedRow, bulkEditDltSelectedRow, bulkEditPurSelectedRow, bulkEditMainSelectedRow]);

  const setSplitPaneSize = (splitSize) => {
    setSizes(splitSize);
  };

  // 新規作成の項目値を変更した場合、
  const onChangeInputForm = (value, isCheckZenkaku = true) => {
    if (isCheckZenkaku && regexExp.test(value)) {
      // 全角の場合、
      value = toHalfWidth(value); // 半角へ変換
    }
    return value;
  };

  const coeffTypeMap = {
    1: orderFilteredData,
    2: deliTimeFilteredData,
    3: purchaseFilteredData,
    4: maintainFilteredData,
    6: toleranceFilteredData,
    7: weldFinishLevelFilteredData,
    8: finalPurposFilteredData,
  };

  const handleCoeffTypeChange = (e) => {
    const selectedType = e.target.value;
    setCoeffType(selectedType);

    const dataArray = coeffTypeMap[selectedType] || [];
    const nextCode = `COF-${(dataArray.length + 1).toString().padStart(4, '0')}`;
    setCode(nextCode);
  };

  // 入力項目情報
  const inputFormItem = (
    <RTable id="param_detail_tbl" className="propertiesTbl">
      <thead>
        {/* 種類名 */}
        {isCreateNew ? (
          <tr className="detail-tbl-row">
            <td className="param-detail-tbl-val-title">
              <label className="param_detail-title-label">係数種類名</label>
            </td>
            <td style={{ verticalAlign: 'middle' }}>
              <RadioGroup
                name="coeffType"
                defaultValue={coeffType}
                className="radioCustomerGpEdit"
                onChange={handleCoeffTypeChange}
                value={coeffType}
              >
                {coefficientTypeAdd?.map((item, index) => (
                  <Radio key={index} value={item.value}>
                    {item.label}
                  </Radio>
                ))}
              </RadioGroup>
            </td>
          </tr>
        ) : (
          <></>
        )}

        {/* コード */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">コード</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              className={'input-editable'}
              name="code"
              id="code"
              value={code}
              type="text"
              ref={(ref) => {
                inputItemRef['code'] = ref;
              }}
              maxLength={50}
              onChange={(e) => setCode(e.target.value)}
            />
          </td>
        </tr>
        {/* 名称 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">名称</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              className={'input-editable'}
              name="name"
              id="name"
              value={name}
              type="text"
              ref={(ref) => {
                inputItemRef['name'] = ref;
              }}
              maxLength={50}
              onChange={(e) => setName(e.target.value)}
            />
          </td>
        </tr>
        {/* 係数 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">係数</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              className={'input-editable'}
              name="coefficient"
              id="coefficient"
              value={coefficient}
              type="text"
              ref={(ref) => {
                inputItemRef['coefficient'] = ref;
              }}
              maxLength={Number.MAX_SAFE_INTEGER}
              onBlur={(e) => setCoefficient(toDecimal(onChangeInputForm(e.target.value), 2))}
              onPressEnter={(e) => setCoefficient(toDecimal(onChangeInputForm(e.target.value), 2))}
              onChange={(e) => setCoefficient(onChangeInputForm(e.target.value, false))}
              onKeyPress={(e) => handleKeyPress(e, false)}
            />
          </td>
        </tr>

        {/* ソート番号 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">ソート番号</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <Input
              className={'input-editable'}
              name="sortNo"
              id="sortNo"
              value={sortNo}
              type="text"
              ref={(ref) => {
                inputItemRef['sortNo'] = ref;
              }}
              maxLength={Number.MAX_SAFE_INTEGER}
              onBlur={(e) => setSortNo(onChangeInputForm(e.target.value))}
              onPressEnter={(e) => setSortNo(onChangeInputForm(e.target.value))}
              onChange={(e) => setSortNo(onChangeInputForm(e.target.value, false))}
              onKeyPress={(e) => handleKeyPress(e, true)}
            />
          </td>
        </tr>
        {/* 作成日 更新日 */}
        {isBulkEdit ? (
          ''
        ) : (
          <>
            <tr className="detail-tbl-row">
              <td className="param-detail-tbl-val-title">
                <label className="param_detail-title-label">作成日</label>
              </td>
              <td style={{ verticalAlign: 'middle' }}>
                <label className="param_detail-title-label">{created}</label>
              </td>
            </tr>

            <tr className="detail-tbl-row">
              <td className="param-detail-tbl-val-title">
                <label className="param_detail-title-label">更新日</label>
              </td>
              <td style={{ verticalAlign: 'middle' }}>
                <label className="param_detail-title-label">{updated}</label>
              </td>
            </tr>
          </>
        )}
        {/* 備考 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">備考</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <TextArea
              className={'input-editable'}
              name="remarks"
              id="remarks"
              value={remarks}
              type="text"
              maxLength={2048}
              style={{ margin: 5, padding: 5, width: '98.3%' }}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </td>
        </tr>
        {/* 表示 */}
        <tr className="detail-tbl-row">
          <td className="param-detail-tbl-val-title">
            <label className="param_detail-title-label">表示</label>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <RadioGroup
              name="display"
              defaultValue={display}
              className="radioCustomerGpEdit"
              onChange={(e) => setDisplay(e.target.value)}
              value={display}
            >
              <Radio value={true}>オン</Radio>
              <Radio value={false}>オフ</Radio>
            </RadioGroup>
          </td>
        </tr>
      </thead>
    </RTable>
  );

  // 選択中行のデータを取得する
  const getSelectedData = (data, key) => {
    let ret = [];
    let record;
    record = data?.find((item) => item.id === key);
    return record ? record : ret;
  };

  // 一覧画面の行を選択した場合、
  const onRowSelect = (record, tblNo) => {
    let selectedData = [];
    selectedData.push({
      id: record.id,
      isUsed: record.isUsed,
      code: record.code,
      name: record.name,
      coeff: record.coeff,
      estimateDays: record.estimateDays,
      remarks: record.remarks,
      sortNum: record.sortNum,
      created: record.created,
      modified: record.modified,
      managementCoeffThMaster: record.managementCoeffThMaster ? record.managementCoeffThMaster : [],
      managementCoeffThItems: record.managementCoeffThItems ? record.managementCoeffThItems : [],
      setupCoeffThMaster: record.setupCoeffThMaster ? record.setupCoeffThMaster : [],
      setupCoeffThItems: record.setupCoeffThItems ? record.setupCoeffThItems : [],
      productCoeffThMaster: record.productCoeffThMaster ? record.productCoeffThMaster : [],
      productCoeffThItems: record.productCoeffThItems ? record.productCoeffThItems : [],
    });
    setChangeRecordKey(record.id);
    setChangeTableNo(tblNo);
    if (editMode) {
      setDiscardChangeMode(discardChange[0]);
      setEditModeCancelConfirm(true);
    } else {
      setTableNo(tblNo);
      setSelectedRowKeys(record.id);
      setSelectedData(selectedData[0]);
      navigate(':common.coefficient');
    }
    props?.updateSelectedRowId(record?.id, tblNo, 0, 'ASC', 'id', {
      keyword: keyword,
      dataState: dataState,
    });
    props?.resetInitialParam();
  };

  // 一覧画面の行を選択した場合、
  const onRowSelectWithoutEditMode = (record, tblNo) => {
    let selectedData = [];
    selectedData.push({
      id: record.id,
      isUsed: record.isUsed,
      code: record.code,
      name: record.name,
      isUsed: record.isUsed,
      estimateDays: record.estimateDays,
      remarks: record.remarks,
      sortNum: record.sortNum,
      created: record.created,
      modified: record.modified,

      // tableNo: record.tableNo,
    });
    setChangeRecordKey(record.id);
    setChangeTableNo(tblNo);

    setTableNo(tblNo);
    setSelectedRowKeys(record.id);
    setSelectedData(record /* selectedData[0] */);
    navigate(':common.coefficient');
    props?.updateSelectedRowId(record?.id, tblNo, 0, 'ASC', 'id', {
      keyword: keyword,
      dataState: dataState,
    });
  };

  const handleOkCSVInput = (e) => {
    setVisibleCSVInput(false);
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv';
    input.onchange = (_) => {
      let files = Array.from(input.files);
    };
    input.click();
  };

  const handleOkXMLInput = (e) => {
    setVisibleXMLInput(false);
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xml';
    input.onchange = (_) => {
      let files = Array.from(input.files);
    };
    input.click();
  };

  // 削除ボタンを押下
  const deleteProcess = () => {
    let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
    if (!moveInEdit) {
      setIsDelete(false);
      deleteOk();
    } else {
      setIsDelete(true);
      setChildTitle('削除');
    }
  };

  const deleteAllProcess = () => {
    let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
    if (!moveInEdit) {
      setIsDeleteAll(false);
      deleteAllRecord();
    } else {
      setIsDeleteAll(true);
    }
  };

  const deleteAllCancel = () => {
    setIsDeleteAll(false);
  };

  const deleteAllRecord = async () => {
    if (isDeleteAll) {
      setIsDeleteAll(false);
      setEditMode(false);
      props?.loading(true); // Waitingダイアログを表示にする
      let deletedData = await deleteAllCoeffDB();
      if (deletedData) {
        getCoefficientData();
      }
      props?.loading(false); // Waitingダイアログを非表示にする
    }
  };

  async function deleteAllCoeffDB(id, tblNo) {
    let ret = false;
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Company/delete-all';

      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = true;
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const bulkDeleteProcess = () => {
    let moveInEdit = props.showConfirmMsgs.moveInEdit == undefined ? true : props.showConfirmMsgs.moveInEdit;
    if (!moveInEdit) {
      setIsDelete(false);
      // bulkDeleteOk();
    } else {
      setIsBulkDelete(true);
    }
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionOrder = {
    selectedRowKeys: selectedRowsOrderTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsOrderTable(
        selectedRows.map((row) => ({
          tableNo: 1,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionDeliTime = {
    selectedRowKeys: selectedRowsDeliTimeTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsDeliTimeTable(
        selectedRows.map((row) => ({
          tableNo: 2,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionPurchase = {
    selectedRowKeys: selectedRowsPurchaseTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsPurchaseTable(
        selectedRows.map((row) => ({
          tableNo: 3,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionMaintain = {
    selectedRowKeys: selectedRowsMaintainTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsMaintainTable(
        selectedRows.map((row) => ({
          tableNo: 4,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionTolerance = {
    selectedRowKeys: selectedRowsToleranceTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsToleranceTable(
        selectedRows.map((row) => ({
          tableNo: 6,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionWeldFinish = {
    selectedRowKeys: selectedRowsWeldFinishTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsWeldFinishTable(
        selectedRows.map((row) => ({
          tableNo: 7,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionFinalPurpos = {
    selectedRowKeys: selectedRowsFinalPurposTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsFinalPurposTable(
        selectedRows.map((row) => ({
          tableNo: 8,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionSetup = {
    selectedRowKeys: selectedRowsSetupTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsSetupTable(
        selectedRows.map((row) => ({
          tableNo: 9,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const rowSelectionProduct = {
    selectedRowKeys: selectedRowsProductTable.map((r) => r.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowsProductTable(
        selectedRows.map((row) => ({
          tableNo: 10,
          id: row.id,
        }))
      );
    },
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const bulkDeleteCancel = async () => {
    setBulkDeleteLoading(false);
    setIsBulkDelete(false);
    setDeleteSelectedRowKeys([]);
  };

  // 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい
  const bulkDeleteOk = async () => {
    const allSelectedRows = [
      ...selectedRowsOrderTable,
      ...selectedRowsDeliTimeTable,
      ...selectedRowsPurchaseTable,
      ...selectedRowsMaintainTable,
      ...selectedRowsToleranceTable,
      ...selectedRowsWeldFinishTable,
      ...selectedRowsFinalPurposTable,
      ...selectedRowsSetupTable,
      ...selectedRowsProductTable,
    ];

    if (allSelectedRows.length === 0) return;

    props?.loading(true);

    for (let row of allSelectedRows) {
      const deletedData = getRelatedCoeff(await deleteCoeffDB(row.id, row.tableNo), row.tableNo);
      if (deletedData?.length > 0) {
        const filtered = deletedData.filter((item) => !item.isDeleted);
        setFilteredDataByType(row.tableNo, filtered);
        setDataByType(row.tableNo, filtered);
      }
    }

    complete(`${allSelectedRows.length} 件のデータを削除しました`);

    setSelectedRowsOrderTable([]);
    setSelectedRowsDeliTimeTable([]);
    setSelectedRowsPurchaseTable([]);
    setSelectedRowsMaintainTable([]);
    setSelectedRowsToleranceTable([]);
    setSelectedRowsWeldFinishTable([]);
    setSelectedRowsFinalPurposTable([]);
    setSelectedRowsSetupTable([]);
    setSelectedRowsProductTable([]);

    props?.loading(false);
  };

  // 削除確認ポップアップのOKボタンを押下
  const deleteOk = async (e) => {
    if (isDelete) {
      setIsDelete(false);
      setEditMode(false);
      props?.loading(true); // Waitingダイアログを表示にする
      let selectedKey = selectedRowKeys;
      let deletedData = getRelatedCoeff(await deleteCoeffDB(selectedKey, tableNo), tableNo);
      // IQX_WEBEST-281 使用しているパラメータなのに削除出来てしまう
      if (deletedData !== undefined && deletedData?.length > 0) {
        let filterdData =
          deletedData !== undefined && deletedData?.length > 0 ? deletedData?.filter((item) => !item.isDeleted) : [];
        setFilteredDataByType(tableNo, filterdData);

        let currentData = filterdData;
        setDataByType(tableNo, currentData);

        // 一番上のテーブルの最初の行を選択
        let rowSelectTbl = [];
        let tbl;
        outerLoop: for (let i = 1; i <= 4; i++) {
          if (i === tableNo && filterdData?.length <= 0) {
            continue outerLoop;
          }
          if (getDataByType(i)?.length > 0) {
            rowSelectTbl = getDataByType(i);
            tbl = i;
            break outerLoop;
          }
        }
        let lastKey = rowSelectTbl[0]?.id;
        let record = getSelectedData(rowSelectTbl, lastKey);
        onRowSelectWithoutEditMode(record, tbl);
      }
      props?.loading(false); // Waitingダイアログを非表示にする
    }
  };

  // 係数情報をDBに削除するt
  async function deleteCoeffDB(id, tblNo) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Company/' + id + '/tbl/' + tblNo;

      const otherParam = {
        method: 'DELETE',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 削除確認ポップアップのCandelボタンを押下
  const deleteCancel = (e) => {
    setIsDelete(false);
  };

  const showCSVInputModal = () => {
    setVisibleCSVInput(true);
    setChildTitle('CSV入力');
  };

  const showXMLInputModal = () => {
    setVisibleXMLInput(true);
    setChildTitle('XML入力');
  };

  const resetInputInfo = (insert = false) => {
    if (insert) {
      const maxCode = orderFilteredData ? orderFilteredData?.length : 0;
      const nextCode = `COF-${(maxCode + 1).toString().padStart(4, '0')}`;
      setCode(nextCode);
    } else {
      setCode('');
    }
    setCoeffType(1);
    setDisplay();
    // setCode('');
    setName('');
    setCoefficient('');
    setEstimateDays('');
    setRemarks('');
    setSortNo();
    setCreated('');
    setUpdated(today);
  };

  // 表示を押下の場合、
  const searchByDataState = (value) => {
    dataState === value ? getDataByFilter() : setDataState(value);
    setIsFilterFlg(true);
  };

  // キーワードで検索した場合、
  const searchByKeyword = (e) => {
    keyword === e.target.value ? getDataByFilter() : setKeyWord(e.target.value);
    setIsFilterFlg(true);
  };

  // 絞り込み、
  const getDataByFilter = () => {
    let searchBarText = keyword;
    let flag;
    let currentData = [];
    let currentFilterData = [];
    let getAllFilteredData = [];
    let isDataExist = false;
    for (let i = 1; i <= 8; i++) {
      currentData = getDataByType(i);
      /* if (currentData?.length <= 0) {
        return;
      } */
      currentFilterData = currentData;
      // キーワードで絞り込み
      if (searchBarText != '') {
        currentFilterData = currentData?.filter(
          (item) =>
            item.code?.toLowerCase().includes(searchBarText?.toLowerCase()) ||
            item.name?.toLowerCase().includes(searchBarText?.toLowerCase()) ||
            item.coefficient?.toLowerCase().includes(searchBarText?.toLowerCase()) ||
            item.sortNum == searchBarText ||
            item.remarks?.toLowerCase().includes(searchBarText?.toLowerCase()) ||
            item.created?.toLowerCase().includes(searchBarText?.toLowerCase()) ||
            item.updated?.toLowerCase().includes(searchBarText?.toLowerCase())
        );
      }

      //  表示で絞り込み
      if (dataState === 1 || dataState === 2) {
        dataState === 1 ? (flag = true) : (flag = false);
        currentFilterData = currentFilterData?.filter((item) => item.isUsed === flag);
      }

      // 「費用・ラベル・メモ・日付」を絞り込んだ、纏め情報
      getAllFilteredData.push({ id: i, data: currentFilterData });
    }

    let index = getAllFilteredData?.findIndex((item) => item.key === selectedRowKeys && item.tableNo === tableNo);
    // 検索した結果に、選択中行のKeyが無い場合、
    /*  if (index === -1) {
      // 編集中である場合、
      if (editMode) {
        setDiscardChangeMode(discardChange[1]);
        setEditModeCancelConfirm(true);
        return;
      }
      // 検索結果がある場合、
      if (getAllFilteredData?.length > 0) {
        index = getAllFilteredData?.length - 1;
        setTableNo(getAllFilteredData[index]?.tableNo);
        setSelectedRowKeys(getAllFilteredData[index]?.key);
        scrollTo('table' + getAllFilteredData[index]?.tableNo);
      }
    } 

    // 検索結果の有無チェック、
    getAllFilteredData?.length > 0 ? setSelectedData(getAllFilteredData[index]) : setSelectedData(getAllFilteredData);*/

    // 一覧に表示するデータ
    if (getAllFilteredData !== undefined && getAllFilteredData?.length > 0) {
      for (let i = 0; i < 8; i++) {
        //let tmpData = getAllFilteredData?.filter((item) => item.tableNo === i);
        setFilteredDataByType(getAllFilteredData[i]?.id, getAllFilteredData[i]?.data);
      }
    }
    props?.updateSelectedRowId(selectedRowKeys, tableNo, 0, 'ASC', 'id', {
      keyword: keyword,
      dataState: dataState,
    });
    setIsFilterFlg(false);
  };

  // Scrollの移動
  const scrollTo = (index) => {
    // Scrollの移動
    document.getElementById(index)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  const reportModalTitle = (
    <div
      style={{
        width: 520,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>確認</p>
    </div>
  );

  const editModalTitle = (
    <div
      style={{
        width: 1300,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const addNewModalTitle = (
    <div
      style={{
        width: 700,
        backgroundColor: '#005fab',
        marginLeft: -10,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  // 確認ポップアップのOKボタン押下
  const confirmOk = async (e) => {
    let tempCoefficientData = prepareCreateNewInfo();
    let bulkEditSelectedRow = [
      { key: 1, data: bulkEditOrdSelectedRow, tableNo: 1 },
      { key: 2, data: bulkEditDltSelectedRow, tableNo: 2 },
      { key: 3, data: bulkEditPurSelectedRow, tableNo: 3 },
      { key: 4, data: bulkEditMainSelectedRow, tableNo: 4 },
      // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
      { key: 5, data: bulkEditOrderTypeSelectedRow, tableNo: 5 },
      { key: 6, data: bulkEditToleranceSelectedRow, tableNo: 6 },
      { key: 7, data: bulkEditWeldFinishLevelSelectedRow, tableNo: 7 },
      { key: 8, data: bulkEditFinalPurposSelectedRow, tableNo: 8 },
      //
    ];
    setCreateConfirm(false);
    if (isCreateNew) {
      let lastIndex = tempCoefficientData?.length - 1;
      let tempData = tempCoefficientData[lastIndex];
      if (!(await detailRef.current.formValidation(inputItemRef, formValidatorMode.Create, tempData.tableNo))) {
        return;
      }
      props?.loading(true); // Waitingダイアログを表示にする
      let createdData = getRelatedCoeff(await insertCoeffDB(tempData), tempData.tableNo);
      // let currentFilterData = getFilteredDataByType(coeffType);
      setDataByType(tempData.tableNo, createdData);
      setFilteredDataByType(
        tempData.tableNo,
        createdData?.filter((item) => !item.isDeleted && item.isUsed)
      );
      if (createdData !== undefined && createdData?.length > 0) {
        onRowSelectWithoutEditMode(createdData[0], tempData.tableNo);
      }
      setIsCreateNew(false);
      scrollTo('table' + tempData.tableNo);
      props?.loading(false); // Waitingダイアログを非表示にする
    } else if (isBulkEdit) {
      setUpdateConfirm(false);
      // 画面の入力チェック
      if (!(await detailRef.current.formValidation(inputItemRef, formValidatorMode.BulkEdit))) {
        return;
      }
      // 一括編集画面から遷移された場合、
      setIsBulkEdit(false);
      props?.loading(true); // Waitingダイアログを表示にする
      // 選択された全ての対象行を更新、
      for (let i = 0; i < bulkEditSelectedRow?.length; i++) {
        let bulkEditSelected = bulkEditSelectedRow[i]?.data;
        if (bulkEditSelected?.length > 0) {
          for (let j = 0; j < bulkEditSelected?.length; j++) {
            let item = bulkEditSelected[j];
            if (display === true || display === false) item.isUsed = display;
            if (code) item.code = code;
            if (name) item.name = name;
            if (coefficient) item.coefficient = coefficient;
            if (remarks) item.remarks = remarks;
            if (sortNo) item.sortNum = sortNo;
            item.updated = today;
            await submitData(item, bulkEditSelectedRow[i]?.tableNo);
          }
        }
      }
      setIsFilterFlg(true);
      props?.loading(false); // Waitingダイアログを非表示にする
    }
    resetInputInfo();
  };

  // 案件状態情報をDBに新規登録する
  async function insertCoeffDB(createData) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Company';
      const otherParam = {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          tableNo: createData.tableNo,
          companyCoeff: createData.coeffInfo,
          coeffDeliveryDate: createData.coeffInfo,
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 確認ポップアップのCancelボタン押下
  const confirmCancel = () => {
    setUpdateConfirm(false);
    setCreateConfirm(false);
  };

  // 編集中破壊確認ポップアップのOKボタン押下
  const discardConfirmOk = () => {
    setEditModeCancelConfirm(false);
    detailRef.current.discardConfirmOk();
  };

  // 編集中破壊確認ポップアップのCancelボタン押下
  const discardConfirmCancel = () => {
    setEditModeCancelConfirm(false);
    detailRef.current.discardConfirmCancel();
  };

  // 破壊確認ポップアップのOKボタン押下
  const cancelConfirmOK = () => {
    if (isCreateNew) {
      setIsCreateNew(false);
    } else if (isBulkEdit) {
      setIsBulkEdit(false);
    }
    setCancelConfirm(false);
  };

  // 破壊確認ポップアップのCancelボタン押下
  const cancelConfirmCancel = () => {
    setCancelConfirm(false);
  };

  // 更新確認のOKを押下で、一覧画面のデータを反映する
  const submitData = async (updatedData, tblNo) => {
    var id = updatedData.id;
    var index;
    props?.loading(true); // Waitingダイアログを表示にする
    let updatedInfo = getRelatedCoeff(await updateCompanyData(updatedData, tblNo), tblNo);
    index = updatedInfo?.length > 0 ? updatedInfo?.findIndex((data) => data.id == id) : id;
    setDataByType(tblNo, updatedInfo);
    // 2025-05-28 共通パラメータの係数を新規作成について。納入品係数と管理費係数が8個までしか作成できない。そういう仕様でしょうか？
    // 2025-05-28 データを更新した後、データをフィルターする
    // setFilteredDataByType(tblNo, updatedInfo);
    setIsFilterFlg(true);
    let data = updatedInfo[index];
    if (id === selectedRowKeys && tableNo === tblNo) detailRef.current?.displayDetailInfo(data);
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // 取引先情報をDBに更新する
  async function updateCompanyData(updateData, tableNo) {
    let ret = [];
    try {
      const Url = process.env.REACT_APP_BACKEND_API_URL + 'Company';
      const otherParam = {
        method: 'PUT',
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
        body: JSON.stringify({
          tableNo: tableNo,
          companyCoeff: updateData,
          coeffDeliveryDate: {},
        }),
      };

      await fetch(Url, otherParam)
        .then(async (response) => {
          return await response.json();
        })
        .then((data) => {
          if (data && data?.updateToken) {
            // セクションにトークン情報を更新する
            updateAccessToken(data?.updateToken);
          }
          if (data && data.statusCode === StatusCodes.OK) {
            ret = data.data[0];
          } else if (
            data &&
            (data.statusCode === StatusCodes.UNAUTHORIZED || data.statusCode === StatusCodes.CONFLICT)
          ) {
            authorizeError(ErrorMessage()[data?.messageCode]);
            return;
          } else if (data && data.statusCode !== StatusCodes.OK) {
            error(ErrorMessage()[data?.messageCode]);
            return;
          }
        })
        .catch((e) => {
          authorizeError(ErrorMessage().E010);
          return;
        });
    } catch (e) {
      error(e.message);
      return;
    }
    return ret;
  }

  // 受注・納期・購入品・管理によりデータを返す
  const getDataByType = (tableNo) => {
    let tempData = [];
    switch (tableNo) {
      case 1:
        tempData = orderCoeffData !== undefined && orderCoeffData?.length > 0 ? [...orderCoeffData] : [];
        break;
      case 2:
        tempData = deliTimeCoeffData !== undefined && deliTimeCoeffData?.length > 0 ? [...deliTimeCoeffData] : [];
        break;
      case 3:
        tempData = purchaseCoeffData !== undefined && purchaseCoeffData?.length > 0 ? [...purchaseCoeffData] : [];
        break;
      case 4:
        tempData = maintainCoeffData !== undefined && maintainCoeffData?.length > 0 ? [...maintainCoeffData] : [];
        break;
      // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
      case 5:
        tempData = orderTypesCoeffData !== undefined && orderTypesCoeffData?.length > 0 ? [...orderTypesCoeffData] : [];
        break;
      case 6:
        tempData = toleranceCoeffData !== undefined && toleranceCoeffData?.length > 0 ? [...toleranceCoeffData] : [];
        break;
      case 7:
        tempData =
          weldFinishLevelCoeffData !== undefined && weldFinishLevelCoeffData?.length > 0
            ? [...weldFinishLevelCoeffData]
            : [];
        break;
      case 8:
        tempData =
          finalPurposCoeffData !== undefined && finalPurposCoeffData?.length > 0 ? [...finalPurposCoeffData] : [];
        //
        break;
    }
    return tempData;
  };

  // 絞り込んだ「受注・納期・購入品・管理」によりデータを返す
  const getFilteredDataByType = (tableNo) => {
    let tempData = [];
    switch (tableNo) {
      case 1:
        tempData = [...orderFilteredData];
        break;
      case 2:
        tempData = [...deliTimeFilteredData];
        break;
      case 3:
        tempData = [...purchaseFilteredData];
        break;
      case 4:
        tempData = [...maintainFilteredData];
        break;
      // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
      case 5:
        tempData = [...orderTypesFilteredData];
        break;
      case 6:
        tempData = [...toleranceFilteredData];
        break;
      case 7:
        tempData = [...weldFinishLevelFilteredData];
        break;
      case 8:
        tempData = [...finalPurposFilteredData];
        break;
      //
    }
    return tempData;
  };

  // 絞り込んだ「受注・納期・購入品・管理」によりデータを返す
  const getRelatedCoeff = (companyData, tableNo) => {
    let tmpData = [];
    switch (tableNo) {
      case 1:
        tmpData = companyData.coeffOrders;
        break;
      case 2:
        tmpData = companyData.coeffDeliveryDates;
        break;
      case 3:
        tmpData = companyData.coeffPurchases;
        break;
      case 4:
        tmpData = companyData.coeffManagements;
        break;
      // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
      case 5:
        tmpData = companyData.coeffOrderTypes;
        break;
      case 6:
        tmpData = companyData.coeffTolerance;
        break;
      case 7:
        tmpData = companyData.coeffWeldFinishLevel;
        break;
      case 8:
        tmpData = companyData.coeffFinalPurpose;
        break;
      case 9:
        tmpData = companyData.coeffSetups;
        break;
      case 10:
        tmpData = companyData.coeffProducts;
        break;
      //
    }
    return tmpData;
  };

  // 受注・納期・購入品・管理によりデータを保存する
  const setDataByType = (tableNo, value) => {
    switch (tableNo) {
      case 1:
        setOrderCoeffData(value);
        setOrderCoeffDataTmp(value);
        break;
      case 2:
        setDeliTimeCoeffData(value);
        setDeliTimeCoeffDataTmp(value);
        break;
      case 3:
        setPurchaseCoeffData(value);
        setPurchaseCoeffDataTmp(value);
        break;
      case 4:
        setMaintainCoeffData(value);
        setMaintainCoeffDataTmp(value);
        break;
      case 9:
        setSetupCoeffData(value);
        setSetupCoeffDataTmp(value);
      case 10:
        setProductCoeffData(value);
        setProductCoeffDataTmp(value);
    }
  };

  // 絞り込んだ「受注・納期・購入品・管理」によりデータを保存する
  const setFilteredDataByType = (tableNo, value) => {
    switch (tableNo) {
      case 1:
        setOrderFilteredData(value);
        break;
      case 2:
        setDeliTimeFilteredData(value);
        break;
      case 3:
        setPurchaseFilteredData(value);
        break;
      case 4:
        setMaintainFilteredData(value);
        break;
      // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
      case 5:
        setOrderTypesFilteredData(value);
        break;
      case 6:
        setToleranceFilteredData(value);
        break;
      case 7:
        setWeldFinishLevelFilteredData(value);
        break;
      case 8:
        setFinalPurposFilteredData(value);
        break;
      case 9:
        setSetupFilteredData(value);
        break;
      case 10:
        setProductFilteredData(value);
        break;
    }
  };

  const clickOrderCoeff = () => {
    setIsOrderCoeff(!isOrderCoeff);
  };

  const clickDeliTimeCoeff = () => {
    setIsDeliTimeCoeff(!isDeliTimeCoeff);
  };

  const clickPurchaseCoeff = () => {
    setIsPurchaseCoeff(!isPurchaseCoeff);
  };

  const clickMaintainCoeff = () => {
    setIsMaintainCoeff(!isMaintainCoeff);
  };

  const clickBulkEditOrderCoeff = () => {
    setIsBulkEditOrderCoeff(!isBulkEditOrderCoeff);
  };

  const clickBulkEditDeliTimeCoeff = () => {
    setIsBulkEditDeliTimeCoeff(!isBulkEditDeliTimeCoeff);
  };

  const clickBulkEditPurchaseCoeff = () => {
    setIsBulkEditPurchaseCoeff(!isBulkEditPurchaseCoeff);
  };

  const clickBulkEditMaintainCoeff = () => {
    setIsBulkEditMaintainCoeff(!isBulkEditMaintainCoeff);
  };

  // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
  const clickOrderTypeCoeff = () => {
    setIsOrderTypeCoeff(!isOrderTypeCoeff);
  };

  const clickToleranceCoeff = () => {
    setIsToleranceCoeff(!isToleranceCoeff);
  };

  const clickWeldFinishiCoeff = () => {
    setIsWeldFinishLevelCoeff(!isWeldFinishLevelCoeff);
  };

  const clickFinalPurposCoeff = () => {
    setIsFinalPurposCoeff(!isFinalPurposCoeff);
  };

  const clickBulkEditOrderTypeCoeff = () => {
    setIsBulkEditOrderTypeCoeff(!isBulkEditOrderTypeCoeff);
  };

  const clickBulkEditToleranceCoeff = () => {
    setIsBulkEditToleranceCoeff(!isBulkEditToleranceCoeff);
  };

  const clickBulkEditWeldFinishLevelCoeff = () => {
    setIsBulkEditWeldFinishLevelCoeff(!isBulkEditWeldFinishLevelCoeff);
  };

  const clickBulkEditFinalPurposCoeff = () => {
    setIsBulkEditFinalPurposCoeff(!isBulkEditFinalPurposCoeff);
  };
  //
  const clickSetupCoeff = () => {
    setIsSetupCoeff(!isSetupCoeff);
  };

  const clickProductCoeff = () => {
    setIsProductCoeff(!isProductCoeff);
  };

  // 編集モードを変更
  const updateEditMode = (mode) => {
    setEditMode(mode);
    props.updateMainParameterEditMode(mode);
  };

  // 新規作成-開始
  const createNewProcess = () => {
    resetInputInfo(true);
    setIsCreateNew(true);
    setCreated(today);
    setUpdated(today);
    setDisplay(true);
    setChildTitle('係数（新規作成）');
  };

  const createNewOK = () => {
    setCreateConfirm(true);
  };

  const createNewCancel = (e) => {
    setCancelConfirm(true);
  };

  // 入力した新規情報を取得する
  const prepareCreateNewInfo = () => {
    let tempData = getDataByType(coeffType);
    let lastIndex = tempData?.length - 1;
    let coeffInfo = {
      coeff: coefficient,
      // estimateDays: estimateDays,
      remarks: remarks,
      sortNum: sortNo, // IQX_WEBEST-376 パラメーター係数画面に新規追加したら、ソート番号が保存されていない。
      isUsed: display,
      code: code,
      name: name,
    };
    tempData.push({
      coeffInfo: coeffInfo,
      tableNo: coeffType,
    });
    return tempData;
    // setTempCoefficientData(tempData);
  };

  const createNewTitle = (
    <div
      style={{
        width: 800,
        backgroundColor: '#005fab',
        marginLeft: -10,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const createNewContent = (
    <>
      <Row style={{ paddingBottom: 0, paddingTop: 0 }}>
        {/** プロパティレイアウト */}
        <Col span={24}>
          <div
            style={{
              height: 475,
              // marginTop: 28,
              fontSize: '13.5px',
              overflowY: 'auto',
              whiteSpace: 'nowrap',
            }}
          >
            {inputFormItem}
          </div>
        </Col>
      </Row>
      <Row
        justify="end"
        style={{
          marginBottom: 0,
          marginTop: 0,
        }}
      >
        <Button className="mainButton" onClick={createNewOK} style={{ marginRight: 5 }}>
          登録
        </Button>
        <Button className="cancelButton" onClick={createNewCancel}>
          {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
          {/* 破棄 */}
          戻る
        </Button>
      </Row>
    </>
  );
  // 新規作成-終了

  // 一括編集-開始
  const onRowOrdCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditOrdSelectedRow([...record]);
    setBulkEditOrdSelectedKeys(checkedRow);
    navigate(':common.coefficient');
  };

  const onRowDltCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditDltSelectedRow([...record]);
    setBulkEditDltSelectedKeys(checkedRow);
    navigate(':common.coefficient');
  };

  const onRowPurCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditPurSelectedRow([...record]);
    setBulkEditPurSelectedKeys(checkedRow);
    navigate(':common.coefficient');
  };

  const onRowMainCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditMainSelectedRow([...record]);
    setBulkEditMainSelectedKeys(checkedRow);
    navigate(':common.coefficient');
  };

  // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
  const onRowOrderTypeCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditOrderTypeSelectedRow([...record]);
    setBulkEditOrderTypeSelectedKeys(checkedRow);
    navigate(':common.coefficient');
  };

  const onRowToleranceCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditToleranceSelectedRow([...record]);
    setBulkEditToleranceSelectedKeys(checkedRow);
    navigate(':common.coefficient');
  };

  const onRowWeldFinishLevelCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditWeldFinishLevelSelectedRow([...record]);
    setBulkEditWeldFinishLevelSelectedKeys(checkedRow);
    navigate(':common.coefficient');
  };

  const onRowFinalPurposCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditFinalPurposSelectedRow([...record]);
    setBulkEditFinalPurposSelectedKeys(checkedRow);
    navigate(':common.coefficient');
  };
  //

  const bulkEditOrdRowSelect = {
    onChange: onRowOrdCheckboxSelect,
  };

  const bulkEditDltRowSelect = {
    onChange: onRowDltCheckboxSelect,
  };

  const bulkEditPurRowSelect = {
    onChange: onRowPurCheckboxSelect,
  };

  const bulkEditMainRowSelect = {
    onChange: onRowMainCheckboxSelect,
  };

  // RealGoku(発注分類)計算の対応
  const bulkEditOrderTypeRowSelect = {
    onChange: onRowOrderTypeCheckboxSelect,
  };
  // RealGoku(公差)計算の対応
  const bulkEditToleranceRowSelect = {
    onChange: onRowToleranceCheckboxSelect,
  };
  // RealGoku(仕上げレベル)計算の対応
  const bulkEditWeldFinishLevelRowSelect = {
    onChange: onRowWeldFinishLevelCheckboxSelect,
  };
  // RealGoku(最終用途)計算の対応
  const bulkEditFinalPurposRowSelect = {
    onChange: onRowFinalPurposCheckboxSelect,
  };
  //

  const bulkEditProcess = () => {
    resetInputInfo();
    setBulkEditOrdSelectedRow([]);
    setBulkEditDltSelectedRow([]);
    setBulkEditPurSelectedRow([]);
    setBulkEditMainSelectedRow([]);
    setBulkEditOrdSelectedKeys([]);
    setBulkEditDltSelectedKeys([]);
    setBulkEditPurSelectedKeys([]);
    setBulkEditMainSelectedKeys([]);

    // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
    setBulkEditOrderTypeSelectedRow([]);
    setBulkEditToleranceSelectedRow([]);
    setBulkEditWeldFinishLevelSelectedRow([]);
    setBulkEditFinalPurposSelectedRow([]);
    setBulkEditOrderTypeSelectedKeys([]);
    setBulkEditToleranceSelectedKeys([]);
    setBulkEditWeldFinishLevelSelectedKeys([]);
    setBulkEditFinalPurposSelectedKeys([]);
    //
    setChkRowsCount(0);
    setIsBulkEdit(true);
    setChildTitle('係数（選択したデータをまとめて編集）');
  };

  const bulkEditOK = (e) => {
    setUpdateConfirm(true);
  };

  const bulkEditCancel = (e) => {
    setCancelConfirm(true);
  };

  const bulkEditTitle = (
    <div
      style={{
        width: 1790,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const bulkEditContent = (
    <>
      <Row style={{ paddingBottom: 0, paddingTop: 0 }}>
        {/** 一覧 */}
        <Col span={13}>
          <p style={{ fontSize: '13.5px', marginBottom: 6, marginTop: 0, fontWeight: '700' }}>
            {chkrowscount}件を選択中
          </p>
          <div className="overflow-auto" style={{ height: 750 }}>
            {/* 受注係数 */}
            <Row
              style={{ color: 'black', marginTop: 0 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditOrderCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[0]?.label}</label>
                  {isBulkEditOrderCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditOrderCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={orderFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditOrdSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditOrdRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
            {/* 納期係数 */}
            <Row
              style={{ color: 'black', marginTop: 5 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditDeliTimeCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[1]?.label}</label>
                  {isBulkEditDeliTimeCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditDeliTimeCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={deliTimeTableColumns}
                  rowKey={(record) => record.id}
                  dataSource={deliTimeFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditDltSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditDltRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
            {/* 購入品係数 */}
            <Row
              style={{ color: 'black', marginTop: 5 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditPurchaseCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[2]?.label}</label>
                  {isBulkEditPurchaseCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditPurchaseCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={purchaseFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditPurSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditPurRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
            {/* 管理費係数 */}
            <Row
              style={{ color: 'black', marginTop: 5 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditMaintainCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[3]?.label}</label>
                  {isBulkEditMaintainCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditMaintainCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={maintainFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditMainSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditMainRowSelect}
                  pagination={false}
                />
              </Row>
            </div>

            {/* RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応 */}
            {/* 発注分類 */}
            <Row
              style={{ color: 'black', marginTop: 0 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditOrderTypeCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[4]?.label}</label>
                  {isBulkEditOrderTypeCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditOrderTypeCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={orderTypesFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditOrderTypeSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditOrderTypeRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
            {/* 公差 */}
            <Row
              style={{ color: 'black', marginTop: 0 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditToleranceCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[5]?.label}</label>
                  {isBulkEditToleranceCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditToleranceCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={toleranceFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditToleranceSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditToleranceRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
            {/* 仕上げレベル */}
            <Row
              style={{ color: 'black', marginTop: 0 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditWeldFinishLevelCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[6]?.label}</label>
                  {isBulkEditWeldFinishLevelCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditWeldFinishLevelCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={weldFinishLevelFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) =>
                    record.key == bulkEditWeldFinishLevelSelectedKeys ? 'active-row' : 'data-row'
                  }
                  rowSelection={bulkEditWeldFinishLevelRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
            {/* 最終用途 */}
            <Row
              style={{ color: 'black', marginTop: 0 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditFinalPurposCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[7]?.label}</label>
                  {isBulkEditFinalPurposCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditFinalPurposCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={finalPurposFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditFinalPurposSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditFinalPurposRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
            {/* 段取係数 */}
            <Row
              style={{ color: 'black', marginTop: 5 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditMaintainCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[8]?.label}</label>
                  {isBulkEditMaintainCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditMaintainCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={maintainFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditMainSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditMainRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
            {/* 子部品生産個数係数 */}
            <Row
              style={{ color: 'black', marginTop: 5 }}
              className="oyabuhin oyabuhin-row"
              onClick={clickBulkEditMaintainCoeff}
            >
              <Col span={20} className="deli-col">
                <div style={{ display: 'flex' }}>
                  <label>{coefficientType[9]?.label}</label>
                  {isBulkEditMaintainCoeff ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5 }} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ display: isBulkEditMaintainCoeff ? 'block' : 'none' }}>
              {/* 一覧アリア */}
              <Row style={{ marginTop: 5 }}>
                <Table
                  showSorterTooltip={false}
                  className="drop-down-tbl"
                  columns={columns}
                  rowKey={(record) => record.id}
                  dataSource={maintainFilteredData}
                  scroll={{ y: 250, x: '10vw' }}
                  rowClassName={(record) => (record.key == bulkEditMainSelectedKeys ? 'active-row' : 'data-row')}
                  rowSelection={bulkEditMainRowSelect}
                  pagination={false}
                />
              </Row>
            </div>
          </div>
        </Col>
        {/** プロパティレイアウト */}
        <Col span={11}>
          <div
            style={{
              height: 749,
              marginTop: 28,
              fontSize: '13.5px',
              overflowY: 'auto',
              whiteSpace: 'nowrap',
            }}
          >
            {inputFormItem}
          </div>
        </Col>
      </Row>
      <Row
        justify="end"
        style={{
          marginBottom: 0,
          marginTop: -40,
        }}
      >
        <Button className="mainButton" onClick={bulkEditOK} style={{ marginRight: 5 }}>
          更新
        </Button>
        <Button className="cancelButton" onClick={bulkEditCancel}>
          {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
          {/* 破棄 */}
          戻る
        </Button>
      </Row>
    </>
  );
  // 一括編集-終了

  // CSVヘッダの情報
  const getCSVHeaderInfo = () => {
    let str = '';
    columns?.map((col, index) => {
      if (index === 1) {
        str += ',係数タイプ';
      }
      if (str.length === 0) {
        str += col.title;
      } else {
        str += ',' + col.title;
      }
    }); // ヘッダの情報
    str = 'ID,' + str;
    return str;
  };

  // CSV出力情報
  const getCsvExportData = () => {
    let str = '';
    str = getCSVHeaderInfo();
    let no = 0;
    orderFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[0]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 受注係数
    deliTimeFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[1]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 納期係数
    purchaseFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[2]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 購入品係数
    maintainFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[3]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 管理費係数
    // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
    orderTypesFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[4]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 発注分類
    toleranceFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[5]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 公差
    weldFinishLevelFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[6]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 仕上げレベル
    finalPurposFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[7]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 最終用途
    setupFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[8]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 段取係数
    productFilteredData.map((data) => {
      // CSV内容
      str +=
        '\n' +
        data.id +
        ',' +
        (no += 1) +
        ',' +
        coefficientType[9]?.label +
        ',' +
        data.code +
        ',' +
        data.name +
        ',' +
        data.coeff +
        ',' +
        data.sortNum +
        ',' +
        formatDate(data.created) +
        ',' +
        formatDate(data.modified) +
        ',' +
        data.remarks +
        ',' +
        data.isUsed;
    }); // 子部品生産個数係数
    return str;
  };

  // CSV入力情報
  const submitCsvImportData = async (dataList) => {
    let createdDatas = [];
    let failedDatas = [];
    messageRef.current = [];
    let orderCoeffDatas = [];
    let deliTimeCoeffDatas = [];
    let maintainCoeffDatas = [];
    let coeffPurchases = [];
    let selectedData = [];
    let tempDatas = [];
    // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
    let orderTypesCoeffDatas = [];
    let toleranceCoeffDatas = [];
    let weldFinishiLevelCoeffDatas = [];
    let finalPurposCoeffDatas = [];
    //段取係数、子部品生産個数係数
    let setupCoeffDatas = [];
    let productCoeffDatas = [];

    props?.loading(true); // Waitingダイアログを表示にする
    // ヘッダの情報
    if (JSON.stringify(dataList[0]) !== JSON.stringify(getCSVHeaderInfo())) {
      // 不正なヘッダの情報
      messageRef?.current?.push(<li>{ErrorMessage('1行目').E016}</li>);
    } else {
      for (let i = 1; i < dataList.length; i++) {
        let coeffInfo = {
          coeff: '',
          remarks: '',
          sortNum: '', // IQX_WEBEST-376 パラメーター係数画面に新規追加したら、ソート番号が保存されていない。
          isUsed: true,
          code: '',
          name: '',
        };
        let tempData = {
          companyCoeff: coeffInfo,
          tableNo: '',
          coeffDeliveryDate: coeffInfo,
        };
        let data = dataList[i]?.split(',');
        if (data && data?.[0]?.length === 0) continue;
        if (!csvImportDataValidation(i + 1, data)) {
          failedDatas.push(dataList[i]);
          continue;
        }

        let tableNo = coefficientType?.find((item) => item.label === data?.[2])?.value;
        //　IQX_WEBEST-377 パラメーター係数のCSV入力がうまくできていない。
        if (tableNo === 2) {
          tempData.coeffDeliveryDate.id = data?.[0];
          tempData.coeffDeliveryDate.code = data?.[3];
          tempData.coeffDeliveryDate.name = data?.[4];
          tempData.coeffDeliveryDate.coeff = data?.[5];
          tempData.coeffDeliveryDate.sortNum = data?.[6]; // IQX_WEBEST-376 パラメーター係数画面に新規追加したら、ソート番号が保存されていない。
          tempData.coeffDeliveryDate.remarks = data?.[9];
          tempData.coeffDeliveryDate.isUsed = data?.[10] ? JSON.parse(data?.[10]?.toLowerCase()) : true; // IQX_WEBEST-301
        } else {
          tempData.companyCoeff.id = data?.[0];
          tempData.companyCoeff.code = data?.[3];
          tempData.companyCoeff.name = data?.[4];
          tempData.companyCoeff.coeff = data?.[5];
          tempData.companyCoeff.sortNum = data?.[6]; // IQX_WEBEST-376 パラメーター係数画面に新規追加したら、ソート番号が保存されていない。
          tempData.companyCoeff.remarks = data?.[9];
          tempData.companyCoeff.isUsed = data?.[10] ? JSON.parse(data?.[10]?.toLowerCase()) : true; // IQX_WEBEST-301
        }
        tempData.tableNo = tableNo;
        tempDatas.push(tempData);
      }
      createdDatas = await createCoeffCSV(tempDatas);
      if (createdDatas !== undefined && createdDatas?.length > 0) {
        orderCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffOrders?.filter((item) => !item.isDeleted) : [];
        selectedData = orderCoeffDatas;
        deliTimeCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffDeliveryDates?.filter((item) => !item.isDeleted) : [];
        maintainCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffManagements?.filter((item) => !item.isDeleted) : [];
        coeffPurchases =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffPurchases?.filter((item) => !item.isDeleted) : [];

        // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
        orderTypesCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffOrderTypes?.filter((item) => !item.isDeleted) : [];
        toleranceCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffTolerance?.filter((item) => !item.isDeleted) : [];
        weldFinishiLevelCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffWeldFinishLevel?.filter((item) => !item.isDeleted) : [];
        finalPurposCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffFinalPurpose?.filter((item) => !item.isDeleted) : [];
        //段取係数、子部品生産個数係数
        setupCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffSetups?.filter((item) => !item.isDeleted) : [];
        productCoeffDatas =
          createdDatas?.length > 0 ? createdDatas[0]?.coeffProducts?.filter((item) => !item.isDeleted) : [];

        setDeliTimeCoeffData(deliTimeCoeffDatas);
        setDeliTimeFilteredData(deliTimeCoeffDatas?.filter((item) => item.isUsed === true));

        setPurchaseCoeffData(coeffPurchases);
        setPurchaseFilteredData(coeffPurchases?.filter((item) => item.isUsed === true));

        setMaintainCoeffData(maintainCoeffDatas);
        setMaintainFilteredData(maintainCoeffDatas?.filter((item) => item.isUsed === true));

        setOrderCoeffData(orderCoeffDatas);
        setOrderFilteredData(orderCoeffDatas?.filter((item) => item.isUsed === true));

        // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
        setOrderTypesCoeffData(orderTypesCoeffDatas);
        setOrderTypesFilteredData(orderTypesCoeffDatas?.filter((item) => item.isUsed === true));

        setToleranceCoeffData(toleranceCoeffDatas);
        setToleranceFilteredData(toleranceCoeffDatas?.filter((item) => item.isUsed === true));

        setWeldFinishLevelCoeffData(weldFinishiLevelCoeffDatas);
        setWeldFinishLevelFilteredData(weldFinishiLevelCoeffDatas?.filter((item) => item.isUsed === true));

        setFinalPurposCoeffData(finalPurposCoeffDatas);
        setFinalPurposFilteredData(finalPurposCoeffDatas?.filter((item) => item.isUsed === true));

        //段取係数、子部品生産個数係数
        setSetupFilteredData(setupCoeffDatas);
        setProductFilteredData(productCoeffDatas);

        let rowSelectTbl = [];
        let tbl;
        let lastKey;

        switch (true) {
          case orderCoeffDatas?.length != 0 && orderCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = orderCoeffDatas?.filter((item) => item.isUsed);
            tbl = 1;
            lastKey = rowSelectTbl[0]?.id;
            break;
          case deliTimeCoeffDatas?.length != 0 && deliTimeCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = deliTimeCoeffDatas?.filter((item) => item.isUsed);
            tbl = 2;
            lastKey = rowSelectTbl[0]?.id;
            break;
          case coeffPurchases?.length != 0 && coeffPurchases?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = coeffPurchases?.filter((item) => item.isUsed);
            tbl = 3;
            lastKey = rowSelectTbl[0]?.id;
            break;
          case maintainCoeffDatas?.length != 0 && maintainCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = maintainCoeffDatas?.filter((item) => item.isUsed);
            tbl = 4;
            lastKey = rowSelectTbl[0]?.id;
            break;
          // RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応
          case orderTypesCoeffDatas?.length != 0 && orderTypesCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = orderTypesCoeffDatas?.filter((item) => item.isUsed);
            tbl = 5;
            lastKey = rowSelectTbl[0]?.id;
            break;
          case toleranceCoeffDatas?.length != 0 && toleranceCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = toleranceCoeffDatas?.filter((item) => item.isUsed);
            tbl = 6;
            lastKey = rowSelectTbl[0]?.id;
            break;
          case weldFinishiLevelCoeffDatas?.length != 0 &&
            weldFinishiLevelCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = weldFinishiLevelCoeffDatas?.filter((item) => item.isUsed);
            tbl = 7;
            lastKey = rowSelectTbl[0]?.id;
            break;
          case finalPurposCoeffDatas?.length != 0 && finalPurposCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = finalPurposCoeffDatas?.filter((item) => item.isUsed);
            tbl = 8;
            lastKey = rowSelectTbl[0]?.id;
            break;
          //段取係数、子部品生産個数係数
          case setupCoeffDatas?.length != 0 && setupCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = setupCoeffDatas?.filter((item) => item.isUsed);
            tbl = 9;
            lastKey = rowSelectTbl[0]?.id;
            break;
          case productCoeffDatas?.length != 0 && productCoeffDatas?.filter((item) => item.isUsed)?.length != 0:
            rowSelectTbl = productCoeffDatas?.filter((item) => item.isUsed);
            tbl = 10;
            lastKey = rowSelectTbl[0]?.id;
            break;
          default:
            rowSelectTbl = orderCoeffDatas;
            tbl = 1;
            lastKey = rowSelectTbl[0]?.id;
        }

        let record = getSelectedData(rowSelectTbl, lastKey);
        onRowSelectWithoutEditMode(record, tbl);

        setSelectedRowKeys(lastKey);
        setSelectedData(record);
        setSelectedRowsData(rowSelectTbl);
        setTableNo(tbl);
        setDataState(1);
        setFilteredDataByType(tbl, rowSelectTbl);
        props?.updateSelectedRowId(record?.[0]?.id, tbl, 0, 'ASC', 'id', {
          keyword: keyword,
          dataState: dataState,
        });
        // setFilteredDataByType(
        //   tempDatas?.[0]?.tableNo,
        //   createdDatas?.filter((item) => !item.isDeleted)
        // );
        // onRowSelectWithoutEditMode(createdData[createdData?.length - 1], tempData.tableNo);
      }
    }
    Modal.success({
      width: 500,
      className: 'modal-complete csv-modal-complete',
      title: '完了',
      content: (
        <p style={{ fontSize: '13.5px', whiteSpace: 'pre-line', lineHeight: 2 }}>
          {'CSV入力のデータ保存は完了しました。正常：' + tempDatas?.length + '件、異常：' + failedDatas?.length + '件'}
          {messageRef.current?.length > 0 ? (
            <>
              <br></br>
              {'下記の内容をご確認ください。'}
              <br></br>
              <ul>{messageRef.current}</ul>
            </>
          ) : (
            <></>
          )}
        </p>
      ),
    });
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // CSV入力情報チェック
  const csvImportDataValidation = (lineNo, data) => {
    // CSV入力情報チェック
    let no = lineNo + '行目の';

    // 係数タイプ
    let input = data[2];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('係数タイプ').E007}</li>);
      return false;
    }
    if (coefficientType.findIndex((item) => item.label === input) === -1) {
      // 不正な係数タイプ
      messageRef?.current?.push(<li>{no + ErrorMessage('係数タイプ').E016}</li>);
      return false;
    }

    // コード
    input = data[3];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('コード').E007}</li>);
      return false;
    }

    // 名称
    input = data[4];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('名称').E007}</li>);
      return false;
    }

    // 係数
    input = data[5];
    if (input?.length <= 0) {
      // 必須
      messageRef?.current?.push(<li>{no + ErrorMessage('係数').E007}</li>);
      return false;
    }

    if (input?.length > 0 && !isDecimal(input)) {
      messageRef?.current?.push(<li>{no + ErrorMessage('係数').E009}</li>);
      return false;
    }

    // ソート番号
    input = data[6];
    if (input?.length > 0 && !isDigit(input)) {
      messageRef?.current?.push(<li>{no + ErrorMessage('ソート番号').E009}</li>);
      return false;
    }

    return true;
  };

  // CSV入力ボタンを押下した場合、
  const onClickCSVImport = () => {
    props?.onClickCSVImport();
  };

  // CSV出力ボタンを押下した場合、
  const onClickCSVExport = () => {
    props?.onClickCSVExport();
  };

  return (
    <>
      {/* 一覧とプロパティ表示 */}
      <div
        style={{
          height: '90.8vh',
          marginLeft: 10,
        }}
      >
        <SplitPane split="vertical" sizes={sizes} onChange={setSizes} resizerSize={1}>
          <div style={{ marginTop: 7 }}>
            {/* 検索アリア */}
            <Space size="middle">
              <Input
                className="input-editable search-select-input"
                placeholder="キーワードを入力"
                allowClear
                onPressEnter={searchByKeyword}
                onBlur={searchByKeyword}
                // onChange={(e) => {
                //   if (e.target.value === '') {
                //     searchByKeyword(e);
                //   }
                // }}
                onChange={searchByKeyword}
                value={keyword}
              />
              <Select
                className="search-select"
                onChange={searchByDataState}
                id="dataStateDrop"
                name="dataStateDrop"
                value={dataState}
              >
                {dataStateList?.map((item, index) => (
                  <Select.Option key={index} id={'dataState' + item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </Space>

            <div className="overflow-auto kouteical " style={{ height: 830 }}>
              {/* 受注係数 */}
              <Row
                style={{ color: 'black', marginTop: 10 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickOrderCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[0]?.label}</label>
                    {isOrderCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isOrderCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table1"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={orderFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 1 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 1);
                          //setChangeTableNo(1);
                        },
                      };
                    }}
                  />
                </Row>
              </div>

              {/* 納期係数 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickDeliTimeCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[1]?.label}</label>
                    {isDeliTimeCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isDeliTimeCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table2"
                    columns={hasCheckData ? deliTimeTableColumns /* columns */ : chkData}
                    dataSource={deliTimeFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 2 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 2);
                          // setChangeTableNo(2);
                        },
                      };
                    }}
                  />
                </Row>
              </div>

              {/* 購入品係数 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickPurchaseCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[2]?.label}</label>
                    {isPurchaseCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isPurchaseCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table3"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={purchaseFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 3 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 3);
                          // setChangeTableNo(3);
                        },
                      };
                    }}
                  />
                </Row>
              </div>

              {/* 管理費係数 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickMaintainCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[3]?.label}</label>
                    {isMaintainCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isMaintainCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table4"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={maintainFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 4 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 4);
                          //setChangeTableNo(4);
                        },
                      };
                    }}
                  />
                </Row>
              </div>

              {/* RealGoku(最終用途、公差、仕上げレベル、最終用途)計算の対応 */}
              {/* 発注分類は発注係数と同じのため、削除*/}

              {/* 公差 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickToleranceCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[5]?.label}</label>
                    {isToleranceCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isToleranceCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table5"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={toleranceFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 6 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 6);
                          //setChangeTableNo(4);
                        },
                      };
                    }}
                  />
                </Row>
              </div>

              {/* 仕上げレベル */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickWeldFinishiCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[6]?.label}</label>
                    {isWeldFinishLevelCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isWeldFinishLevelCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table5"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={weldFinishLevelFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 7 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 7);
                          //setChangeTableNo(4);
                        },
                      };
                    }}
                  />
                </Row>
              </div>

              {/* 最終用途 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickFinalPurposCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[7]?.label}</label>
                    {isFinalPurposCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isFinalPurposCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table5"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={finalPurposFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 8 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 8);
                          //setChangeTableNo(4);
                        },
                      };
                    }}
                  />
                </Row>
              </div>
              {/* 段取係数 */}
              <Row style={{ color: 'black', marginTop: 5 }} className="oyabuhin oyabuhin-row" onClick={clickSetupCoeff}>
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[8]?.label}</label>
                    {isSetupCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isSetupCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table9"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={setupFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 9 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 9);
                        },
                      };
                    }}
                  />
                </Row>
              </div>
              {/* 子部品生産個数係数 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickProductCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[9]?.label}</label>
                    {isProductCoeff ? (
                      <CaretUpOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18, marginTop: 2, marginLeft: 5, color: 'white' }} />
                    )}
                  </div>
                </Col>
              </Row>
              <div style={{ display: isProductCoeff ? 'block' : 'none' }}>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    showSorterTooltip={false}
                    id="table10"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={productFilteredData}
                    scroll={{ y: 180, x: '10vw' }}
                    rowClassName={(record) =>
                      record.id == selectedRowKeys && 10 === tableNo ? 'active-row' : 'data-row'
                    }
                    pagination={false}
                    className="drop-down-tbl"
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          onRowSelect(record, 10);
                          //setChangeTableNo(4);
                        },
                      };
                    }}
                  />
                </Row>
              </div>
            </div>
          </div>
          {/* プロパティ表示 */}
          <div>
            <Routes>
              <Route
                exact
                path=":common.coefficient"
                element={
                  <CoefficientDetails
                    ref={detailRef}
                    editMode={editMode}
                    selectedData={selectedData}
                    submitData={submitData}
                    updateEditMode={updateEditMode}
                    onChangeInputForm={onChangeInputForm}
                    tableNo={tableNo}
                    showEdtConfirmOK={showEdtConfirmOK}
                    showEdtConfirmCancle={showEdtConfirmCancle}
                    detailWidth={sizes[1]}
                  />
                }
              />
            </Routes>
          </div>
        </SplitPane>
      </div>

      {/* 新規作成 */}
      {isCreateNew
        ? commonModal(
            isCreateNew,
            createNewTitle,
            null,
            null,
            800,
            createNewOK,
            createNewCancel,
            createNewContent,
            'addNewCustomerModal',
            null,
            true
          )
        : ''}

      {/* 一括編集 */}
      {isBulkEdit
        ? commonModal(
            isBulkEdit,
            bulkEditTitle,
            null,
            null,
            1790,
            bulkEditOK,
            bulkEditCancel,
            bulkEditContent,
            'updateModalStyle',
            null,
            true
          )
        : ''}

      {/* 削除 */}
      {isDelete
        ? commonResponsiveConfirmModal(
            isDelete,
            confirmModalTitle,
            commonDeleteFooter(deleteOk, deleteCancel),
            null,
            400,
            deleteOk,
            deleteCancel,
            editMode ? confirmDiscardAndDeleteContent : confirmDeleteContent,
            null,
            null,
            false
          )
        : ''}

      {/* CSV取込 */}
      {/* <Modal
        title={reportModalTitle}
        open={visibleCSVInput}
        onOk={handleOkCSVInput}
        onCancel={handleCancel}
        footer={[
          <Button key="file" type="primary" onClick={handleOkCSVInput} className="mainButton">
            OK
          </Button>,
          <Button key="back" onClick={handleCancel} className="cancelButton">
            キャンセル
          </Button>,
        ]}
        closeIcon={<CloseOutlined style={{ color: 'white' }} />}
      >
        <p style={{ fontSize: '13.5px' }}>
          PCに保存した情報を読み込みます。<br></br>よろしいでしょうか？
        </p>
      </Modal> */}

      {/* XML呼出 */}
      {/* <Modal
        title={reportModalTitle}
        open={visibleXMLInput}
        onOk={handleOkXMLInput}
        onCancel={handleCancel}
        footer={[
          <Button key="file" type="primary" onClick={handleOkXMLInput} className="mainButton">
            OK
          </Button>,
          <Button key="back" onClick={handleCancel} className="cancelButton">
            キャンセル
          </Button>,
        ]}
        closeIcon={<CloseOutlined style={{ color: 'white' }} />}
      >
        <p style={{ fontSize: '13.5px' }}>
          装置情報（時間チャージ、段取設定、加工設定）を初期パラメータ作成情報から
          <br />
          取り込みます。
          <br />
          装置情報は、呼出情報で更新されます。
        </p>
      </Modal> */}

      {/* 登録確認 */}
      {createConfirm
        ? commonResponsiveConfirmModal(
            createConfirm,
            confirmModalTitle,
            commonFooter(confirmOk, confirmCancel),
            null,
            400,
            confirmOk,
            confirmCancel,
            confirmCreateContent,
            null,
            null,
            false
          )
        : ''}

      {/* 更新確認 */}
      {updateConfirm
        ? commonResponsiveConfirmModal(
            updateConfirm,
            confirmModalTitle,
            commonFooter(confirmOk, confirmCancel),
            null,
            400,
            confirmOk,
            confirmCancel,
            confirmUpdateContent,
            null,
            null,
            false
          )
        : ''}

      {/** 破棄の確認メッセージ */}
      {cancelConfirm
        ? commonResponsiveConfirmModal(
            cancelConfirm,
            confirmModalTitle,
            commonFooter(cancelConfirmOK, cancelConfirmCancel),
            null,
            400,
            cancelConfirmOK,
            cancelConfirmCancel,
            confirmDiscardContent,
            null,
            null,
            false
          )
        : ''}

      {/** 編集中破棄確認ポップアップ */}
      {editModeCancelConfirm
        ? commonResponsiveConfirmModal(
            editModeCancelConfirm,
            confirmModalTitle,
            commonFooter(discardConfirmOk, discardConfirmCancel),
            null,
            400,
            discardConfirmOk,
            discardConfirmCancel,
            confirmHakiContent,
            null,
            null,
            false
          )
        : ''}

      {/* 2025-10-14 IQX_WEBEST-486 複数削除ができてほしい */}
      {isBulkDelete && (
        <Modal
          maskClosable={false}
          open={isBulkDelete}
          title={bulkDeleteModalTitle}
          footer={null} // ここでフッターは自前で作る
          width={1670}
          bodyStyle={{
            maxHeight: '80vh',
            overflow: 'hidden', // 内部にスクロールする div があるので body は hidden
            margin: 0,
            padding: 0,
          }}
          onCancel={bulkDeleteCancel}
          closeIcon={<CloseOutlined style={{ color: 'white' }} />}
          centered={false}
          modalRender={(modal) => (
            <Draggable handle=".ant-modal-header">
              <div>{modal}</div>
            </Draggable>
          )}
        >
          <Spin spinning={bulkDeleteLoading} tip="Loading..." size="large">
            {/* スクロール可能部分 */}
            <div
              style={{
                height: 'calc(80vh - 60px)', // ボタン分の高さを引く
                overflowY: 'auto',
                padding: '10px',
              }}
            >
              {/* 受注係数 */}
              <Row
                style={{ color: 'black', marginTop: 10 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickOrderCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[0]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table1"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={orderFilteredData}
                    rowSelection={rowSelectionOrder}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>

              {/* 納期係数 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickDeliTimeCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[1]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table2"
                    columns={hasCheckData ? deliTimeTableColumns /* columns */ : chkData}
                    dataSource={deliTimeFilteredData}
                    rowSelection={rowSelectionDeliTime}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>

              {/* 購入品係数 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickPurchaseCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[2]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table3"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={purchaseFilteredData}
                    rowSelection={rowSelectionPurchase}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>

              {/* 管理費係数 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickMaintainCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[3]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table4"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={maintainFilteredData}
                    rowSelection={rowSelectionMaintain}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>

              {/* 公差 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickToleranceCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[5]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table5"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={toleranceFilteredData}
                    rowSelection={rowSelectionTolerance}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>

              {/* 仕上げレベル */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickWeldFinishiCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[6]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table5"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={weldFinishLevelFilteredData}
                    rowSelection={rowSelectionWeldFinish}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>

              {/* 最終用途 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickFinalPurposCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[7]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table5"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={finalPurposFilteredData}
                    rowSelection={rowSelectionFinalPurpos}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>
              {/* 段取係数 */}
              <Row style={{ color: 'black', marginTop: 5 }} className="oyabuhin oyabuhin-row" onClick={clickSetupCoeff}>
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[8]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table9"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={setupFilteredData}
                    rowSelection={rowSelectionSetup}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>
              {/* 子部品生産個数係数 */}
              <Row
                style={{ color: 'black', marginTop: 5 }}
                className="oyabuhin oyabuhin-row"
                onClick={clickProductCoeff}
              >
                <Col span={20} className="deli-col">
                  <div style={{ display: 'flex' }}>
                    <label style={{ color: 'white' }}>{coefficientType[9]?.label}</label>
                  </div>
                </Col>
              </Row>
              <div>
                {/* 一覧アリア */}
                <Row style={{ marginTop: 5 }}>
                  <Table
                    rowKey="id"
                    showSorterTooltip={false}
                    id="table10"
                    columns={hasCheckData ? tableColumns : chkData}
                    dataSource={productFilteredData}
                    rowSelection={rowSelectionProduct}
                    scroll={{ y: 180, x: '80vw' }}
                    pagination={false}
                    className="drop-down-tbl"
                  />
                </Row>
              </div>
            </div>
            <div
              style={{
                height: 60, // ボタンエリアの高さ
                padding: '10px 20px',
                borderTop: '1px solid #6c757d',
                display: 'flex',
                justifyContent: 'flex-end',
                background: '#fff',
              }}
            >
              <Button className="mainButton" onClick={bulkDeleteOk} style={{ marginRight: 5 }}>
                削除
              </Button>
              <Button className="cancelButton" onClick={bulkDeleteCancel}>
                閉じる
              </Button>
            </div>
          </Spin>
        </Modal>
      )}

      {isDeleteAll && (
        <Modal
          maskClosable={false}
          open={isDeleteAll}
          title={deleteModalTitle}
          footer={commonDeleteAllFooter(deleteAllRecord, deleteAllCancel)}
          width={400}
          onOk={deleteAllRecord}
          onCancel={deleteAllCancel}
          closeIcon={<CloseOutlined style={{ color: 'white' }} />}
          centered={false}
          modalRender={(modal) => (
            <Draggable handle=".ant-modal-header">
              <div>{modal}</div>
            </Draggable>
          )}
        >
          <div>
            <p style={{ fontSize: '13px', marginBottom: '20px' }}>すべてのデータを削除しますがよろしいですか。</p>
          </div>
        </Modal>
      )}
    </>
  );
});

export default CoefficientParamList;
